import React, { useEffect, useRef, useState } from "react";

import api from "../services/api";
import { useParams, useHistory } from "react-router-dom";
import jwt_decode from "jwt-decode";

import GradientGauge from "../components/modernGauge";
import FullScreenLoader from "../components/fullScreenLoader";
import useWindowSize from "../hooks/useWindowSize";
import logo from "../assets/windradar_logo.png";
import appleBtn from "../assets/avaibleApple.png";
import googleBtn from "../assets/avaibleGoogle.png";

require("dotenv").config();

export default function Dashboard() {
  const [radarDash, setRadarDash] = useState("");
  const [radarLocation, setRadarLocation] = useState("");
  const [usageLimitReached, setUsageLimitReached] = useState(false);

  const [locationName, setLocationName] = useState("Windradar");

  const REFRESH_TIMEOUT = 300000;
  const TOKEN_EXPIRATION = 900000;

  const { width, height, orientation } = useWindowSize();

  const [color, setColor] = useState("#2275FF");
  const { token, location } = useParams();
  const routeToken = token || location;
  const usageHitTokenRef = useRef(null);

  let history = useHistory();

  const ui = buildUIStyles(width, height, orientation);

  const requestLocationHitsUpdate = async (locationId) => {
    try {
      const { data } = await api.patch(
        `/location/url-alias/usage/${locationId}`,
      );

      const {
        url_alias_daily_usage_hits,
        url_alias_daily_usage_limit,
        daily_usege_overcomed,
      } = data ?? {};

      console.log(
        `Dashboard usage limit updating locationId ${locationId} success...`,
      );
      console.log(
        `Dashboard usage stats: hits ${url_alias_daily_usage_hits} of ${url_alias_daily_usage_limit} limit, daily_usege_overcomed ${daily_usege_overcomed ? "reached." : "not reached."}. Success...`,
      );

      return Boolean(daily_usege_overcomed);
    } catch (err) {
      console.log(
        `Dashboard usage limit updating locationId ${locationId} error...`,
      );
      console.error(err);

      return false;
    }
  };

  const api_request = async (shouldUpdateUsageHits = false) => {
    let id_location;
    let id, iat, exp, origin;

    const updateVariables = (obj) => {
      id = obj.id;
      iat = obj.iat;
      exp = obj.exp;
      origin = obj.origin;
    };

    try {
      if (routeToken?.split(".").length === 3) {
        const { id, iat, exp, origin } = jwt_decode(routeToken);
        updateVariables({ id, iat, exp, origin });
      }
    } catch (err) {
      console.info("Dashboard token decode skipped. Trying url_alias.", err);
    }

    //Token decode failure. Must try resolve url_alias
    if (!id || origin !== "dashboard") {
      await api
        .get(`/location/?url_alias=${routeToken}`, {
          headers: {
            authorization: `Bearer ${process.env.REACT_APP_AUTORIZATION}`,
          },
        })
        .then((response) => {
          if (
            !response ||
            response.length === 0 ||
            response.error ||
            !response.data[0]?.id
          ) {
            history.push("/notfound");
          }
          setRadarLocation(response.data);
          document.title = response.data[0]?.campaign?.title
            ? `Windradar - ${response.data[0]?.campaign?.title}`
            : `Dashboard`;
          setLocationName(`${response.data[0]?.spot_name}, ${response.data[0]?.beach.name}
        ${response.data[0]?.beach.location.city.name}/${response.data[0]?.beach.location.state.uf}`);
          id_location = response.data[0]?.id;
        })
        .catch((e) => {
          console.error("erro =>", e);
        });
    } else {
      const now = new Date();
      const due = exp > iat ? exp : iat + TOKEN_EXPIRATION;

      if (!id || origin !== "dashboard") {
        history.push("/notfound");
      }

      if (due < now.getTime()) {
        history.push("/expired");
      }

      await api
        .get(`/location/?id_local=${Number(id)}`, {
          headers: {
            authorization: `Bearer ${process.env.REACT_APP_AUTORIZATION}`,
          },
        })
        .then((response) => {
          if (!response || response.length === 0 || response.error) {
            history.push("/notfound");
          }
          setRadarLocation(response.data);
          document.title = response.data[0]?.campaign?.title
            ? `Windradar - ${response.data[0]?.campaign?.title}`
            : `Dashboard`;
          setLocationName(`${response.data[0]?.spot_name}, ${response.data[0]?.beach.name}
        ${response.data[0]?.beach.location.city.name}/${response.data[0]?.beach.location.state.uf}`);
        })
        .catch((e) => {
          console.error("erro =>", e);
        });

      id_location = id;
    }

    if (
      shouldUpdateUsageHits &&
      usageHitTokenRef.current !== routeToken &&
      Number.isFinite(Number(id_location)) &&
      Number(id_location) > 0
    ) {
      usageHitTokenRef.current = routeToken;

      const dailyUsageLimitReached =
        await requestLocationHitsUpdate(id_location);

      if (dailyUsageLimitReached) {
        setUsageLimitReached(true);

        return;
      }

      setUsageLimitReached(false);
    }

    await api
      .get(`/v2/radar/dashboard/${Number(id_location)}`, {
        headers: {
          authorization: `Bearer ${process.env.REACT_APP_AUTORIZATION}`,
        },
      })
      .then((response) => {
        if (!response || response.length === 0) {
          history.push("/notfound");
        }
        setRadarDash(response.data);
        setColor(response.data?.instant_measure?.color);
      })
      .catch((e) => {
        console.error("erro =>", e);
      });
  };

  useEffect(() => {
    console.info(routeToken);
    if (routeToken) {
      if (usageHitTokenRef.current !== routeToken) {
        setUsageLimitReached(false);
      }

      api_request(true);
      const refreshInterval = setInterval(() => {
        api_request(false);
      }, REFRESH_TIMEOUT);

      return () => clearInterval(refreshInterval);
    } else {
      history.push("/notfound");
    }
  }, [routeToken, history]);

  const direction = radarDash.instant_measure?.degrees
    ? `${radarDash.instant_measure.cardeal} ${radarDash.instant_measure?.degrees}°`
    : "";

  if (usageLimitReached) {
    return (
      <div style={ui.limitMessage}>
        <h1 style={ui.limitTitle}>Limite diário atingido</h1>
        <p style={ui.limitText}>
          O limite de acessos deste dashboard foi atingido. Tente novamente mais
          tarde.
        </p>
        <p style={ui.limitText}>
          The access limit for this dashboard has been reached. Please try again
          later.
        </p>
      </div>
    );
  }

  if (!radarLocation) {
    return <FullScreenLoader label="Carregando dados..." />;
  }

  const instant = radarDash.instant_measure || {};
  const last = radarDash.last_hour_cards || {};

  /* ───────────────── LAYOUT ───────────────── */

  const LogoHeader = () => (
    <div style={ui.logoContainer}>
      <div style={ui.imageContainer}>
        <img
          src={logo}
          alt="Logo"
          style={{ maxWidth: "100%", maxHeight: "100%", borderRadius: 12 }}
        />
      </div>
      <span style={ui.download}>Instale Agora!</span>
      <div style={ui.btnWrap}>
        <div style={ui.btnContainer}>
          <img
            src={appleBtn}
            alt="Logo"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              borderRadius: 12,
            }}
          />
        </div>

        <div style={ui.btnContainer}>
          <img
            src={googleBtn}
            alt="Logo"
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              borderRadius: 12,
            }}
          />
        </div>
      </div>
    </div>
  );

  const LeftSection = () => {
    const ratio = orientation === "landscape" ? width : height;
    const percentage = orientation === "landscape" ? 25 / 100 : 60 / 100;
    const fontSizeRatio = orientation === "landscape" ? 0.2 : 0.45;
    return (
      <section style={ui.left}>
        {orientation === "portrait" && <LogoHeader />}

        <h2 style={ui.location}>{locationName}</h2>

        <h1 style={ui.agora}>AGORA</h1>

        <GradientGauge
          size={width * percentage}
          value={instant?.sustained || 0}
          max={50}
          unit="Nós"
          direction={direction}
          fontSizeRatio={fontSizeRatio}
        />

        <div style={ui.footerText}>
          {instant?.cardeal} {instant?.degrees}° · {instant?.wind_alignment}
          <br />
          {new Date(instant?.last_measure).toLocaleString("pt-BR")}
        </div>
      </section>
    );
  };

  const RightSection = () => (
    <section style={ui.right}>
      {orientation === "landscape" && <LogoHeader />}

      <h2 style={ui.lastHour}>Última Hora</h2>
      <div style={ui.footerCard}>
        <div style={ui.cards}>
          <StatCard
            color="#8ED000"
            value={last?.sustained}
            footer="Nós"
            label="Média"
            width={width}
            height={height}
            orientation={orientation}
          />
          <StatCard
            color="#D00000"
            value={last?.gust}
            footer="Nós"
            label="Rajada"
            width={width}
            height={height}
            orientation={orientation}
          />
        </div>

        <StatCard
          color="#9CA3AF"
          value={last?.radar_directions?.cardeal || "-"}
          footer={`${last?.radar_directions?.degrees || "--"}°`}
          label="Direção"
          full
          width={width}
          height={height}
          orientation={orientation}
        />
      </div>
    </section>
  );

  return (
    <div style={ui.page}>
      <div style={ui.grid}>
        {/* ───────── LEFT ───────── */}
        <LeftSection />
        {/* ───────── RIGHT ───────── */}
        {orientation === "landscape" && <RightSection />}
      </div>
    </div>
  );
}

/* ───────────────── COMPONENTS ───────────────── */

function StatCard({
  color,
  value,
  footer,
  label,
  full,
  width,
  height,
  orientation,
}) {
  const card = buildCardStyles(width, height, orientation);
  return (
    <div
      style={{
        ...card.base,
        background: color,
        width: full ? "100%" : "auto",
      }}
    >
      <div style={card.value}>{value ?? "-"}</div>
      {footer && <div style={card.footer}>{footer}</div>}
      <div style={card.label}>{label}</div>
    </div>
  );
}

/* ───────────────── STYLES ───────────────── */
function buildUIStyles(width, height, orientation) {
  const fs = (w, ratio, min, max) => Math.max(min, Math.min(w * ratio, max));

  const ratio = orientation === "landscape" ? width : height;
  const fontScale = orientation === "landscape" ? 1 : 1.5;
  const containerScale = orientation === "landscape" ? 1 : 1.5;

  return {
    page: {
      width: "100vw",
      height: "100vh",
      overflow: "hidden",
      background: "#fff",
      fontFamily: "Montserrat",
    },

    grid: {
      display: "grid",
      gridTemplateColumns: orientation === "landscape" ? "1.2fr 1fr" : "1fr",
      height: "100%",
      padding: "4vh 5vw",
      gap: "4vw",
      boxSizing: "border-box",
    },

    imageContainer: {
      width: ((ratio * 20) / 100) * containerScale,
      borderRadius: 16,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },

    logoContainer: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      textAlign: "center",
      width: "100%",
    },

    btnWrap: {
      width: "100%",
      maxWidth: ((ratio * 20) / 100) * containerScale,
      padding: 10,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      margin: "0 auto",
    },

    btnContainer: {
      width: ((ratio * 20) / 100) * containerScale,
      padding: 10,
      borderRadius: 16,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      zIndex: 10,
    },

    left: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "2.5vh",
      textAlign: "center",
    },

    right: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: "3vh",
    },

    /* ─────────────── FONTS (WIDTH-BASED) ─────────────── */

    download: {
      alignItems: "center",
      justifyContent: "center",
      fontSize: fs(ratio, 0.025, 18, 42) * fontScale,
      opacity: 0.8,
    },

    location: {
      fontSize: fs(ratio, 0.02, 14, 28) * fontScale,
      margin: 0,
    },

    agora: {
      fontSize: fs(ratio, 0.04, 26, 64) * fontScale,
      margin: 0,
      fontWeight: "bold",
    },

    lastHour: {
      fontSize: fs(ratio, 0.028, 20, 42) * fontScale,
      margin: "1vh 0",
    },

    footerText: {
      fontSize: fs(ratio, 0.012, 12, 18) * fontScale,
      opacity: 0.7,
      lineHeight: 1.4,
    },

    /* ─────────────── LAYOUT BLOCKS ─────────────── */

    cards: {
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      gap: "2vw",
      width: "100%",
      maxWidth: ((ratio * 30) / 100) * containerScale,
    },

    footerCard: {
      display: "grid",
      gridTemplateColumns: "1fr",
      gap: "2vw",
      width: "100%",
      maxWidth: ((ratio * 30) / 100) * containerScale,
    },

    qr: {
      display: "flex",
      alignItems: "center",
      gap: 12,
      marginTop: "2vh",
      opacity: 0.8,
      fontSize: fs(ratio, 0.012, 12, 18) * fontScale,
    },

    /* ─────────────── LOADER ─────────────── */

    loader: {
      width: "100vw",
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 12,
    },

    spinner: {
      width: 48,
      height: 48,
      border: "6px solid rgba(0,0,0,0.15)",
      borderTop: "6px solid #00E676",
      borderRadius: "50%",
      animation: "spin 1s linear infinite",
    },

    limitMessage: {
      width: "100vw",
      height: "100vh",
      background: "black",
      color: "#fff",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: 24,
      textAlign: "center",
      fontFamily: "Montserrat",
      boxSizing: "border-box",
    },

    limitTitle: {
      margin: 0,
      fontSize: 32,
      fontWeight: 700,
    },

    limitText: {
      maxWidth: 520,
      margin: "16px 0 0",
      fontSize: 18,
      lineHeight: 1.5,
    },
  };
}

/* ───────────────── STYLES ───────────────── */
function buildCardStyles(width, height, orientation) {
  const fs = (w, ratio, min, max) => Math.max(min, Math.min(w * ratio, max));

  const ratio = orientation === "landscape" ? width : height;
  const fontScale = orientation === "landscape" ? 1.2 : 2;
  const containerScale = orientation === "landscape" ? 1 : 1.5;

  const card = {
    base: {
      borderRadius: 14,
      padding: 14,
      color: "#fff",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 6,
      minHeight: ((ratio * 5) / 100) * containerScale,
      boxSizing: "border-box",
    },

    /* MAIN VALUE (number) */
    value: {
      fontSize: fs(ratio, 0.028, 22, 42) * fontScale, // ~2.8% of width
      fontWeight: 700,
      lineHeight: 1,
    },

    /* SMALL FOOTER TEXT */
    footer: {
      fontSize: fs(ratio, 0.014, 12, 20) * fontScale, // ~1.4% of width
      opacity: 0.9,
    },

    /* LABEL BAR */
    label: {
      width: "100%",
      marginTop: 6,
      padding: 6,
      background: "rgba(0,0,0,0.25)",
      borderRadius: 8,
      textAlign: "center",
      fontSize: fs(ratio, 0.013, 11, 18) * fontScale, // ~1.3% of width
    },
  };

  return card;
}
